import React from 'react';
import FormField, { FORM_INPUT_STYLE } from './FormField';

// The client fields shared by the Clients page form and the Program wizard's
// "+ New Client" / "+ New Agency" modal, so the two can't drift apart.
//
// Props:
//   form            { name, sales_person, client_code, agency_id }
//   onChange        (field, value) => void
//   errors?         { name? } from useFormValidation
//   agencyOptions?  [{ value, label }] — renders the Agency select when given.
//                   The wizard omits it: its own Agency picker is the one that
//                   matters for the program.
//   autoFocusName?  focus the Name input on mount
//   onEnter?        called on Enter in a text input (a modal with no <form>)
//   columns?        CSS grid-template-columns (default: auto-fill 200px cards)

export const emptyClientForm = () => ({ name: '', sales_person: '', client_code: '', agency_id: '' });

export default function ClientFormFields({
  form, onChange, errors = {}, agencyOptions, autoFocusName = false, onEnter, columns,
}) {
  const onKeyDown = onEnter ? (e) => { if (e.key === 'Enter') { e.preventDefault(); onEnter(); } } : undefined;
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: columns || 'repeat(auto-fill, minmax(200px, 1fr))',
      gap: '12px',
    }}>
      <FormField label="Name" required error={errors.name}>
        <input
          autoFocus={autoFocusName}
          placeholder="Acme Corp"
          value={form.name}
          onChange={e => onChange('name', e.target.value)}
          onKeyDown={onKeyDown}
          style={{ ...FORM_INPUT_STYLE, border: errors.name ? '1px solid #e74c3c' : FORM_INPUT_STYLE.border }}
        />
      </FormField>
      <FormField label="Sales Person">
        <input
          value={form.sales_person}
          onChange={e => onChange('sales_person', e.target.value)}
          onKeyDown={onKeyDown}
          style={FORM_INPUT_STYLE}
        />
      </FormField>
      <FormField label="Code">
        <input
          placeholder={(form.name || 'XX').slice(0, 2).toUpperCase()}
          title="2-letter NeTRA Lead ID prefix — defaults to the first 2 letters of the name if left blank"
          value={form.client_code}
          maxLength={2}
          onChange={e => onChange('client_code', e.target.value.toUpperCase())}
          onKeyDown={onKeyDown}
          style={FORM_INPUT_STYLE}
        />
      </FormField>
      {agencyOptions && (
        <FormField label="Agency">
          <select value={form.agency_id} onChange={e => onChange('agency_id', e.target.value)} style={FORM_INPUT_STYLE}>
            <option value="">None</option>
            {agencyOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </FormField>
      )}
    </div>
  );
}
